import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ATMIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ATMIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.7998 22C20.522 22 20.2972 21.7752 20.2972 21.4974V13.497L19.5776 3.62756C19.5521 3.27908 19.2581 3.0052 18.9081 3.0052H5.09151C4.74156 3.0052 4.44756 3.27908 4.42202 3.62756L3.701 13.5333L3.70247 21.4974C3.70247 21.7752 3.47767 22 3.19987 22C2.92206 22 2.69727 21.7752 2.69727 21.4974V13.497L3.41976 3.55493C3.48307 2.68323 4.21734 2 5.0915 2H18.9081C19.7823 2 20.5166 2.68323 20.5799 3.55493L21.3009 13.4607L21.3024 21.4974C21.3024 21.7752 21.0776 22 20.7998 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.975 13.1897H8.02466C7.10045 13.1897 6.3485 12.4378 6.3485 11.5131V6.63924C6.3485 5.71454 7.10045 4.96259 8.02466 4.96259H15.975C16.8992 4.96259 17.6511 5.71454 17.6511 6.63924V11.5131C17.6511 12.4378 16.8992 13.1897 15.975 13.1897ZM8.02466 5.9678C7.65458 5.9678 7.35371 6.26916 7.35371 6.63924V11.5131C7.35371 11.8832 7.65458 12.1845 8.02466 12.1845H15.975C16.3451 12.1845 16.6459 11.8832 16.6459 11.5131V6.63924C16.6459 6.26917 16.3451 5.9678 15.975 5.9678H8.02466Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.89911 20.6286H6.88939C6.61159 20.6286 6.38679 20.4038 6.38679 20.126V15.6841C6.38679 15.4063 6.61159 15.1815 6.88939 15.1815H9.89911C10.1769 15.1815 10.4017 15.4063 10.4017 15.6841V20.126C10.4017 20.4038 10.1769 20.6286 9.89911 20.6286ZM7.392 19.6234H9.39651V16.1867H7.392V19.6234Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.8965 16.1867H5.89156C5.61375 16.1867 5.38896 15.9619 5.38896 15.6841C5.38896 15.4063 5.61375 15.1815 5.89156 15.1815H10.8965C11.1743 15.1815 11.3991 15.4063 11.3991 15.6841C11.3991 15.9619 11.1743 16.1867 10.8965 16.1867Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.1716 15.8019C14.1716 16.1898 13.8568 16.5045 13.469 16.5045C13.0811 16.5045 12.7663 16.1897 12.7663 15.8019C12.7663 15.414 13.0811 15.0992 13.469 15.0992C13.8568 15.0992 14.1716 15.414 14.1716 15.8019Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2795 15.8019C16.2795 16.1898 15.9647 16.5045 15.5769 16.5045C15.189 16.5045 14.8742 16.1897 14.8742 15.8019C14.8742 15.414 15.189 15.0992 15.5769 15.0992C15.9647 15.0992 16.2795 15.414 16.2795 15.8019Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.3875 15.8019C18.3875 16.1898 18.0727 16.5045 17.6848 16.5045C17.297 16.5045 16.9822 16.1897 16.9822 15.8019C16.9822 15.414 17.297 15.0992 17.6848 15.0992C18.0727 15.0992 18.3875 15.414 18.3875 15.8019Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.1716 17.9098C14.1716 18.2977 13.8568 18.6124 13.469 18.6124C13.0811 18.6124 12.7663 18.2977 12.7663 17.9098C12.7663 17.5219 13.0811 17.2072 13.469 17.2072C13.8568 17.2072 14.1716 17.5219 14.1716 17.9098Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2795 17.9098C16.2795 18.2977 15.9647 18.6124 15.5769 18.6124C15.189 18.6124 14.8742 18.2977 14.8742 17.9098C14.8742 17.5219 15.189 17.2072 15.5769 17.2072C15.9647 17.2072 16.2795 17.5219 16.2795 17.9098Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.3875 17.9098C18.3875 18.2977 18.0727 18.6124 17.6848 18.6124C17.297 18.6124 16.9822 18.2977 16.9822 17.9098C16.9822 17.5219 17.297 17.2072 17.6848 17.2072C18.0727 17.2072 18.3875 17.5219 18.3875 17.9098Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.1716 20.0178C14.1716 20.4057 13.8568 20.7204 13.469 20.7204C13.0811 20.7204 12.7663 20.4056 12.7663 20.0178C12.7663 19.6299 13.0811 19.3151 13.469 19.3151C13.8568 19.3151 14.1716 19.6299 14.1716 20.0178Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.2795 20.0178C16.2795 20.4057 15.9647 20.7204 15.5769 20.7204C15.189 20.7204 14.8742 20.4056 14.8742 20.0178C14.8742 19.6299 15.189 19.3151 15.5769 19.3151C15.9647 19.3151 16.2795 19.6299 16.2795 20.0178Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.3875 20.0178C18.3875 20.4057 18.0727 20.7204 17.6848 20.7204C17.297 20.7204 16.9822 20.4056 16.9822 20.0178C16.9822 19.6299 17.297 19.3151 17.6848 19.3151C18.0727 19.3151 18.3875 19.6299 18.3875 20.0178Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ATMIcon;
